/**
 * Gallery slider script
 */
class Bookero_SliderGallery {
  constructor (wrapper) {
    this.gallerySliderWrapper = wrapper;
    this.initEvents();
  }

  initEvents() {
    this.prevBtn = this.gallerySliderWrapper.find('.prev');
    this.nextBtn = this.gallerySliderWrapper.find('.next');
    this.list = this.gallerySliderWrapper.find('.slider-gallery-list');
    this.items = this.list.find('.slider-gallery-item');
    this.currentItem = 1;
    this.animationInProgress = false;
    this.swipeEffect = new Hammer(this.gallerySliderWrapper[0]);
    this.list.css('margin-left', (-100 * this.currentItem) + "%");

    if(this.items.length <= 2) {
      this.prevBtn.addClass('is-hidden');
      this.currentItem = 0;
      this.list.css('margin-left', (-100 * this.currentItem) + "%");
    }

    if(this.items.length <= 1) {
      this.prevBtn.addClass('is-hidden');
      this.nextBtn.addClass('is-hidden');
    }

    this.prevBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem--;
      this.animationInProgress = true;

      if (this.currentItem === 0) {
        this.prevBtn.addClass('is-hidden');
      }

      this.items.removeClass('is-active');
      this.items.eq(this.currentItem).addClass('is-active');
      this.list.css('margin-left', (-100 * this.currentItem) + "%");
      this.nextBtn.removeClass('is-hidden');

      setTimeout(() => {
          this.animationInProgress = false;
      }, 250);
    });

    this.nextBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem++;
      this.animationInProgress = true;

      if (this.currentItem === this.items.length - 1) {
        this.nextBtn.addClass('is-hidden');
      }

      if (this.currentItem >= this.items.length) {
        this.currentItem = (this.items.length - 1);
      }

      this.items.removeClass('is-active');
      this.items.eq(this.currentItem).addClass('is-active');
      this.list.css('margin-left', (-100 * this.currentItem) + "%");
      this.prevBtn.removeClass('is-hidden');

      setTimeout(() => {
        this.animationInProgress = false;
      }, 250);
    });

    this.swipeEffect.on('swipe', ev => {
      if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
        if (this.currentItem < this.items.length - 1) {
          this.currentItem++;
        } else {
          this.currentItem = 0;
        }
      }

      if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
        if (this.currentItem > 0) {
          this.currentItem--;
        } else {
          this.currentItem = this.items.length - 1;
        }
      }
    });
  }
}